import { render } from "./B2bPageRecepciones.vue?vue&type=template&id=2ff78858&scoped=true&lang=pug"
import script from "./B2bPageRecepciones.vue?vue&type=script&lang=js"
export * from "./B2bPageRecepciones.vue?vue&type=script&lang=js"

import "./B2bPageRecepciones.vue?vue&type=style&index=0&id=2ff78858&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff78858"]])

export default __exports__